<template>


</template>

<script>


import CurrentUser from "../untils/current-user";

export default {
  name: "login",
  components: {

  },
  created() {
      const {query} = this.$route;
      console.log(query);
      const loginRedirect = sessionStorage.getItem('login_redirect');
      console.log(loginRedirect);
      if(!query.code) {
          this.$dialog.alert({
              title: '错误',
              content: "登录失败，请退出重试",
              confirmText: '确定',
          });
          return false;
      }

      this.$toast.loading("登录中");
      this.$http.post("login", {code:query.code})
          .then(({data}) => {
              this.$toast.hide();
              this.$toast.succeed("登录成功");
              CurrentUser.getInstance().login(data.api_token);
              let redirect = '/';
              if(loginRedirect) {
                  redirect = loginRedirect;
              }
              this.$router.replace(redirect);
          })
          .catch(() => {
              this.$toast.hide()
              this.$dialog.alert({
                  title: '错误',
                  content: "登录失败，请重试",
                  confirmText: '确定',
              });
          });
  },
};
</script>
